export default __webpack_public_path__ + "static/100--stacked-bar-ac414cbc7c53e7ab9f0685a174c5abe6.png";